import React from 'react';
import { XCircle, ArrowLeft, ShoppingBag } from 'lucide-react';
import { Link } from 'react-router-dom';
import TruckLogo from '../components/TruckLogo';
import BusinessFooter from '../components/BusinessFooter';

const CancelPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-100">
      <header className="bg-primary text-white shadow-md">
        <div className="container mx-auto px-4 py-4">
          <div className="flex items-center">
            <TruckLogo size={28} className="text-white mr-2" />
            <h1 className="text-xl font-bold uppercase">COTIZATRIN</h1>
          </div>
        </div>
      </header>

      <main className="container mx-auto px-4 py-8">
        <div className="bg-white rounded-lg shadow-lg p-8 max-w-2xl mx-auto">
          <div className="text-center">
            <div className="bg-gray-100 p-4 rounded-full w-20 h-20 mx-auto mb-6 flex items-center justify-center">
              <XCircle className="h-12 w-12 text-gray-600" />
            </div>
            
            <h1 className="text-3xl font-bold text-gray-800 mb-2">Compra Cancelada</h1>
            <p className="text-gray-600 mb-8">Has cancelado el proceso de compra. No se ha realizado ningún cargo.</p>

            <div className="bg-blue-50 border border-blue-200 rounded-lg p-6 mb-8">
              <h2 className="text-lg font-semibold text-blue-800 mb-4">¿Qué puedes hacer ahora?</h2>
              <div className="text-left space-y-3">
                <div className="flex items-start">
                  <div className="bg-blue-600 text-white rounded-full w-6 h-6 flex items-center justify-center mr-3 flex-shrink-0 mt-0.5 text-sm">
                    1
                  </div>
                  <p className="text-blue-700">
                    <strong>Intentar de nuevo:</strong> Puedes volver a intentar la compra cuando estés listo.
                  </p>
                </div>
                
                <div className="flex items-start">
                  <div className="bg-blue-600 text-white rounded-full w-6 h-6 flex items-center justify-center mr-3 flex-shrink-0 mt-0.5 text-sm">
                    2
                  </div>
                  <p className="text-blue-700">
                    <strong>Explorar opciones:</strong> Revisa los diferentes paquetes de créditos disponibles.
                  </p>
                </div>
                
                <div className="flex items-start">
                  <div className="bg-blue-600 text-white rounded-full w-6 h-6 flex items-center justify-center mr-3 flex-shrink-0 mt-0.5 text-sm">
                    3
                  </div>
                  <p className="text-blue-700">
                    <strong>Continuar usando:</strong> Puedes seguir usando la aplicación con los créditos que ya tienes.
                  </p>
                </div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link
                to="/"
                className="inline-flex items-center px-6 py-3 bg-primary text-white rounded-lg hover:bg-primary-dark transition-colors"
              >
                <ArrowLeft className="mr-2" size={16} />
                Volver al Dashboard
              </Link>
              
              <button
                onClick={() => window.history.back()}
                className="inline-flex items-center px-6 py-3 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors"
              >
                <ShoppingBag className="mr-2" size={16} />
                Intentar de nuevo
              </button>
            </div>
          </div>
        </div>
      </main>

      <BusinessFooter variant="minimal" />
    </div>
  );
};

export default CancelPage;